import { createReducer, on } from '@ngrx/store';
import { SkillsUsage } from '../skills/models/skills-usage.model';
import { Skill } from '../skills/models/skills.model';
import { AdminSkillApiError } from './admin-skills.errors';
import {
  AdminSkillsErroredAction,
  AdminLoadSkillsAction,
  AdminLoadSkillsUsageAction,
  AdminSkillsUsageLoadedAction,
  AdminSkillsLoadedAction,
  AdminDeleteSkillSuccessAction,
  AdminRemoveSkillsErrorAction,
} from './admin-skills.action';

export interface AdminSkillsState {
  skills: Skill[];
  skillsUsage: SkillsUsage[];
  apiError: AdminSkillApiError;
}

export const initialState: AdminSkillsState = {
  skills: [],
  skillsUsage: [],
  apiError: null,
};

export const adminSkillsReducer = createReducer<AdminSkillsState>(
  initialState,
  on(AdminLoadSkillsAction, (state) => ({
    ...state,
    skills: [],
    skillsUsage: [],
    apiError: null,
  })),
  on(AdminLoadSkillsUsageAction, (state) => ({
    ...state,
    skillsUsage: [],
    apiError: null,
  })),
  on(AdminSkillsUsageLoadedAction, (state, { skillsUsage }) => ({
    ...state,
    apiError: null,
    skillsUsage,
  })),
  on(AdminSkillsLoadedAction, (state, { skills }) => ({
    ...state,
    apiError: null,
    skills,
  })),
  on(AdminSkillsErroredAction, (state, { error }) => ({
    ...state,
    apiError: error,
  })),
  on(AdminRemoveSkillsErrorAction, (state) => ({ ...state, apiError: null })),
  on(AdminDeleteSkillSuccessAction, (state, { id }) => ({
    ...state,
    skills: state.skills.filter((it) => it.id != id),
    apiError: null,
  })),
);
